<template>
    <div v-if="car && (car.options?.length || car.additional_equipment)" class="car-equipment">
        <div
            v-if="carSafetyAndDrivingOptions.length > 0"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Безопасность и вождение</div>

            <div class="car-equipment__category-blocks">
                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carSafetyAndDrivingOptions.slice(0, Math.round(carSafetyAndDrivingOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>
                </div>

                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carSafetyAndDrivingOptions.slice(Math.round(carSafetyAndDrivingOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="carOptions.immobilizer || carOptions.central_locking || carOptions.signalling"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Защита от угона</div>

            <div class="car-equipment__category-blocks">
                <div v-if="carOptions.immobilizer" class="car-equipment__category-block list">
                    <div class="car-equipment__category-element">Иммобилайзер</div>
                </div>

                <div v-if="carOptions.central_locking" class="car-equipment__category-block list">
                    <div class="car-equipment__category-element">Центральный замок</div>
                </div>

                <div v-if="carOptions.signalling" class="car-equipment__category-block list">
                    <div class="car-equipment__category-element">Сигнализация</div>
                </div>
            </div>
        </div>

        <div
            v-if="carOptions.conditioner || carOptions.climate !== undefined"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Климат</div>

            <div class="car-equipment__category-blocks">
                <div v-if="carOptions.conditioner" class="car-equipment__category-block list">
                    <div class="car-equipment__category-element car-equipment__category-element_ordinary">
                        <span class="car-equipment__category-label">Кондиционер:</span>
                        <span class="car-equipment__category-value">Есть</span>
                    </div>
                </div>

                <div v-if="carOptions.climate !== undefined" class="car-equipment__category-block list">
                    <div class="car-equipment__category-element car-equipment__category-element_ordinary">
                        <span class="car-equipment__category-label">Климат-контроль:</span>
                        <span class="car-equipment__category-value">{{ carOptions.climate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="carOptions.number_seats !== undefined
                || carOptions.interiortype !== undefined
                || carOptions.panoramic_roof
                || carOptions.leather_wheel
                || carOptions.leather_gearshift
                || carOptions.combination_skin
            "
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Интерьер</div>

            <div class="car-equipment__category-blocks">
                <div class="car-equipment__category-block list">
                    <div v-if="carOptions.number_seats !== undefined" class="car-equipment__category-element car-equipment__category-element_ordinary">
                        <span class="car-equipment__category-label">Количество мест:</span>
                        <span class="car-equipment__category-value">{{ carOptions.number_seats }}</span>
                    </div>

                    <div v-if="carOptions.interiortype !== undefined" class="car-equipment__category-element car-equipment__category-element_ordinary">
                        <span class="car-equipment__category-label">Салон:</span>
                        <span class="car-equipment__category-value">{{ carOptions.interiortype }}</span>
                    </div>

                    <div v-if="carOptions.panoramic_roof" class="car-equipment__category-element">
                        Панорамная крыша
                    </div>

                    <div v-if="carOptions.leather_wheel" class="car-equipment__category-element">
                        Отделка кожей рулевого колеса
                    </div>

                    <div v-if="carOptions.leather_gearshift" class="car-equipment__category-element">
                        Отделка кожей рычага КПП
                    </div>

                    <div v-if="carOptions.combination_skin" class="car-equipment__category-element">
                        Комбинация натуральной и искусственной кожи в отделке сидений
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="carOptions.steering_wheel !== undefined || carComfortOptions.length > 0"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Комфорт</div>

            <div class="car-equipment__category-blocks">
                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carComfortOptions.slice(0, Math.round(carComfortOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>

                    <div v-if="carOptions.steering_wheel !== undefined" class="car-equipment__category-element car-equipment__category-element_ordinary">
                        <span class="car-equipment__category-label">Регулировка руля:</span>
                        <span class="car-equipment__category-value">{{ carOptions.steering_wheel }}</span>
                    </div>
                </div>

                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carComfortOptions.slice(Math.round(carComfortOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="carOptions.wheels_material !== undefined || carOptions.wheels_size !== undefined"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Экстерьер</div>

            <div class="car-equipment__category-blocks">
                <div class="car-equipment__category-block list">
                    <div
                        v-if="carOptions.wheels_material !== undefined"
                        class="car-equipment__category-element car-equipment__category-element_ordinary"
                    >
                        <span class="car-equipment__category-label">Диски:</span>
                        <span class="car-equipment__category-value">{{ carOptions.wheels_material }}</span>
                    </div>

                    <div
                        v-if="carOptions.wheels_size !== undefined"
                        class="car-equipment__category-element car-equipment__category-element_ordinary"
                    >
                        <span class="car-equipment__category-label">Размер:</span>
                        <span class="car-equipment__category-value">{{ carOptions.wheels_size }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="carMultimediaOptions.length > 0"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Мультимедиа</div>

            <div class="car-equipment__category-blocks">
                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carMultimediaOptions.slice(0, Math.round(carMultimediaOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>
                </div>

                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carMultimediaOptions.slice(Math.round(carMultimediaOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="carOptions.headlights !== undefined || carLightingAndVisibilityOptions.length > 0"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Освещение и обзор</div>

            <div class="car-equipment__category-blocks">
                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carLightingAndVisibilityOptions.slice(0, Math.round(carLightingAndVisibilityOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>

                    <div
                        v-if="carOptions.headlights !== undefined"
                        class="car-equipment__category-element car-equipment__category-element_ordinary"
                    >
                        <span class="car-equipment__category-label">Фары:</span>
                        <span class="car-equipment__category-value">{{ carOptions.headlights }}</span>
                    </div>
                </div>

                <div class="car-equipment__category-block list">
                    <div
                        v-for="option in carLightingAndVisibilityOptions.slice(Math.round(carLightingAndVisibilityOptions.length / 2))"
                        class="car-equipment__category-element"
                    >
                        {{ option }}
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="car.additional_equipment"
            class="car-equipment__category"
        >
            <div class="car-equipment__category-title">Дополнительное оборудование</div>

            <div class="car-equipment__category-blocks">{{ car.additional_equipment }}</div>
        </div>
    </div>
    <div v-else>
        нет данных
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';

    import { Car } from '@/types/car.type.ts';
    import {
        ComplectationOption,
        ComplectationOptionsUICreateForm,
        makeComplectationOptionsEmptyUICreateForm,
    } from '@/types/complectation.type.ts';

    const { car } = defineProps<{
        car: Car,
    }>();

    const carOptions = computed<ComplectationOptionsUICreateForm>(() => {
        if (car.options === undefined) {
            return makeComplectationOptionsEmptyUICreateForm();
        }

        const options: Record<string, string | boolean> = makeComplectationOptionsEmptyUICreateForm();
        car.options.forEach((option: ComplectationOption) => {
            options[option.option_symbolic_code] = option.option_value_symbolic_code === 'yes' ? true : option.option_value;
        });

        return { ...makeComplectationOptionsEmptyUICreateForm(), ...options } as ComplectationOptionsUICreateForm;
    });

    const carSafetyAndDrivingOptions = computed<string[]>(() => {
        const options = [];

        if (carOptions.value.abs) {
            options.push('Антиблокировочная система тормозов (ABS)');
        }

        if (carOptions.value.tcs) {
            options.push('Антипробуксовочная система (TCS)');
        }

        if (carOptions.value.hac) {
            options.push('Система помощи при старте в горку (HAC)');
        }

        if (carOptions.value.ebd) {
            options.push('Система распределения тормозных усилий (EBD)');
        }

        if (carOptions.value.isofix) {
            options.push('Крепления для детского кресла ISOFIX');
        }

        if (carOptions.value.rear_door_lock) {
            options.push('Блокировка задних дверей');
        }

        if (carOptions.value.tire_pressure_monitoring) {
            options.push('Система мониторинга давления в шинах');
        }

        if (carOptions.value.glonass) {
            options.push('Устройство вызова экстренных оперативных служба Эра-Глонасс');
        }

        if (carOptions.value.emergency_brake_assist) {
            options.push('Система помощи при экстренном торможении');
        }

        if (carOptions.value.blind_spot_monitoring) {
            options.push('Система мониторинга слепых зон');
        }

        if (carOptions.value.hold_lane_assist) {
            options.push('Ассистент удержания автомобиля в полосе движения');
        }

        if (carOptions.value.driver_tracking_system) {
            options.push('Система слежения за состоянием водителя');
        }

        if (carOptions.value.collision_avoidance_system) {
            options.push('Система предотвращения столкновений');
        }

        if (carOptions.value.front_airbags) {
            options.push('Фронтальные подушки безопасности водителя и переднего пассажира');
        }

        if (carOptions.value.driver_knee_airbag) {
            options.push('Коленная подушка безопасности водителя');
        }

        if (carOptions.value.side_airbags) {
            options.push('Боковые подушки безопасности');
        }

        if (carOptions.value.safety_shutters) {
            options.push('Шторки безопасности');
        }

        return options;
    });

    const carComfortOptions = computed<string[]>(() => {
        const options = [];

        if (carOptions.value.rear_view_camera) {
            options.push('Камера заднего вида');
        }

        if (carOptions.value.all_round_camera) {
            options.push('Камера кругового обзора');
        }

        if (carOptions.value.heated_wheel) {
            options.push('Подогрев руля');
        }

        if (carOptions.value.cruise_control) {
            options.push('Круиз-контроль');
        }

        if (carOptions.value.rear_parking_sensors) {
            options.push('Датчики парковки сзади');
        }

        if (carOptions.value.front_parking_sensors) {
            options.push('Датчики парковки спереди');
        }

        if (carOptions.value.heated_seats) {
            options.push('Подогрев сидений');
        }

        if (carOptions.value.smart_key) {
            options.push('Система "Smart key" — доступ без ключа + кнопка START/STOP');
        }

        if (carOptions.value.roof_rails) {
            options.push('Рейлинги на крыше');
        }

        if (carOptions.value.seat_ventilation) {
            options.push('Вентиляция сидений');
        }

        if (carOptions.value.power_windows) {
            options.push('Электростеклоподъемники (передние и задние)');
        }

        if (carOptions.value.auto_parking_system) {
            options.push('Система автоматической парковки');
        }

        if (carOptions.value.part_folding_baskrest) {
            options.push('Складывающаяся по частям спинка заднего сиденья 60:40');
        }

        if (carOptions.value.power_heated_mirrors) {
            options.push('Зеркала с электроприводом и обогревом');
        }

        if (carOptions.value.electric_driver_seat) {
            options.push('Электрорегулировка сиденья водителя');
        }

        if (carOptions.value.electric_passenger_seat) {
            options.push('Электрорегулировка сиденья пассажира');
        }

        if (carOptions.value.memory_settings) {
            options.push('Память настроек для двух водителей (сиденье, наружные зеркала)');
        }

        if (carOptions.value.power_tailgate) {
            options.push('Электропривод двери багажника');
        }

        return options;
    });

    const carMultimediaOptions = computed<string[]>(() => {
        const options = [];

        if (carOptions.value.native_navigation_system) {
            options.push('Штатная навигационная система');
        }

        if (carOptions.value.multifunction_steering_wheel) {
            options.push('Мультифункциональное рулевое колесо');
        }

        if (carOptions.value.aux) {
            options.push('AUX');
        }

        if (carOptions.value.bluetooth) {
            options.push('Bluetooth');
        }

        if (carOptions.value.usb) {
            options.push('USB');
        }

        if (carOptions.value.socket_12v) {
            options.push('Розетка 12V');
        }

        if (carOptions.value.socket_220v) {
            options.push('Розетка ~220V');
        }

        return options;
    });

    const carLightingAndVisibilityOptions = computed<string[]>(() => {
        const options = [];

        if (carOptions.value.rain_sensor) {
            options.push('Датчик дождя');
        }

        if (carOptions.value.light_sensor) {
            options.push('Датчик света');
        }

        if (carOptions.value.running_lights) {
            options.push('Дневные ходовые огни');
        }

        if (carOptions.value.fog_lights) {
            options.push('Противотуманные фары');
        }

        if (carOptions.value.headlight_washer) {
            options.push('Омыватель фар');
        }

        return options;
    });
</script>

<style scoped lang="scss">
    @use './CarEquipment.scss' as *;
</style>
